import React from 'react'
import { PageProps } from 'gatsby'

import CMS from '@talus-analytics/library.airtable-cms'
import StylesProvider from '../../styles/StylesProvider'
import ConfigProvider from '../context/ConfigProvider'
import { ConfigStyles } from 'styles/types'

import useIconsQuery from '../../cmsHooks/useIconsQuery'
import useSiteMetadataQuery from '../../cmsHooks/useSiteMetadataQuery'
import getTrackingId from '../../utilities/trackingId'

export type LandingPageOptions = 'grid' | 'carousel' | 'none'
export interface Config extends PageProps {
  options: {
    [optionName: string]: string
  }
  siteMap: {
    [page: string]: {
      url?: string
      urlTemplate?: string
      _pageSrc?: string
    }
  }
  styles: ConfigStyles
}
interface ProvidersProps {
  children: React.ReactNode
  config: Config
}
// site-wide contexts for themes, icons, and metadata
const Providers = ({ children, config }: ProvidersProps) => {
  const icons = useIconsQuery()
  const siteMetadata = useSiteMetadataQuery()
  // get GA tracking ID
  const trackingId = getTrackingId()

  return (
    <CMS.IconProvider data={icons}>
      <CMS.SiteMetadataProvider data={siteMetadata} trackingId={trackingId}>
        <ConfigProvider config={config}>
          <StylesProvider styles={config.styles}>{children}</StylesProvider>
        </ConfigProvider>
      </CMS.SiteMetadataProvider>
    </CMS.IconProvider>
  )
}

export default Providers
